export function signalSourceLabel(source: string, feed: string): string {
  return /^(?:shadow-)?sr-/.test(feed) ? "Sportradar" : source;
}
